import * as fromRouter from '@ngrx/router-store';
import {createFeatureSelector} from '@ngrx/store';

const selectRouter =
  createFeatureSelector<fromRouter.RouterReducerState>('router');

const {selectQueryParams, selectUrl} =
  fromRouter.getRouterSelectors(selectRouter);

export const routerSelectors = {
  selectQueryParams,
  selectUrl,
};
